var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplyClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM10.1924 5.80859C9.95807 5.57428 9.57806 5.57428 9.34375 5.80859L8 7.15234L6.65625 5.80859C6.42194 5.57428 6.04291 5.57428 5.80859 5.80859C5.57447 6.04292 5.57434 6.422 5.80859 6.65625L7.15234 8L5.80859 9.34375C5.57434 9.578 5.57447 9.95708 5.80859 10.1914C6.04291 10.4257 6.42194 10.4257 6.65625 10.1914L8 8.84766L9.34375 10.1914C9.57806 10.4257 9.95807 10.4257 10.1924 10.1914C10.4264 9.9571 10.4265 9.57797 10.1924 9.34375L8.84863 8L10.1924 6.65625C10.4265 6.42203 10.4264 6.0429 10.1924 5.80859Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplyClose);
export default __webpack_public_path__ + "static/media/Multiply_close.5ae9c83bc66a05f1349ac282b0f7e73f.svg";
export { ForwardRef as ReactComponent };